import { lazy, Suspense, useState, type ReactNode } from 'react';
import { isDesktopHandoffRequired } from './isMobileDevice';
import type { DesktopHandoffVariant } from './DesktopHandoffScreen';

const DesktopHandoffScreen = lazy(() => import('./DesktopHandoffScreen'));

interface MobileGateProps {
  variant: DesktopHandoffVariant;
  children: ReactNode;
}

function HandoffFallback() {
  return (
    <div className="flex min-h-dvh w-full items-center justify-center bg-x9-marine px-6 text-sm text-white/55">
      Loading&hellip;
    </div>
  );
}

/**
 * Blocks non-mobile browsers with a QR handoff screen. Mobile users and
 * QA bypass (`?allowDesktop=1`) pass through to `children` unchanged.
 */
export default function MobileGate({ variant, children }: MobileGateProps) {
  const [handoffRequired] = useState(() => isDesktopHandoffRequired());

  if (handoffRequired) {
    return (
      <Suspense fallback={<HandoffFallback />}>
        <DesktopHandoffScreen variant={variant} />
      </Suspense>
    );
  }

  return <>{children}</>;
}
